module.exports = __webpack_public_path__ + "static/img/role.abce978.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/yzzzbq/role.png
// module id = 1c8y
// module chunks = 7